import React from "react";
import { Row, Col, Typography } from "antd";
import './EmployeeFollowUpEventDetailListForm.css';
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

const { Text } = Typography;

const QuizGroupForm = ({
    description,
    note,
}) => {
    return (
        <Row gutter={16} >
            <Col xs={24} className="group-title">
                <AdnTextArea
                    placeholder={description}
                    disabled
                    autoSize
                />
                <Text strong italic>{note}</Text>
            </Col>
        </Row>
    );
};

export default QuizGroupForm;